import $ from 'jquery';

var __dealerChatKACOgLength = 0;

export default {
  dealerChat: function () {
    var $liveChatKAC = $("a[data-destination='live-chat-kac']"); // this custom data-destination added via dealer.chat.js previously
    var liveChatKACTimer; // timer store

    if ($liveChatKAC.length) {
      clearTimeout(liveChatKACTimer);

      liveChatKACTimer = setTimeout(function () {
        var ets = document.createElement('script');
        ets.type = 'text/javascript';
        ets.async = true;
        ets.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.engagetosell.com/js/12923.js';
        /* BAT-2915, BAT-3039 Kansas City Engage to Sell on Click to Chat CTAs, instead of Contact at Once
          - only add the script if it doesn't exist already AND if there hasn't since been CTAs added (script needs to be added AFTER all CTAs are in place)
          Note: this checking for script first was an attempt at resolving an issue where CTAs are added after ajax requests (IE: Find a dealer results, dealer component)
          as of July 31, 2017, BAT-3039 we're just not using the CTAs in these problem locations.
        */
        if ($('script[src="' + ets.src + '"]').length === 0) {
          document.body.appendChild(ets);
          __dealerChatKACOgLength = $liveChatKAC.length;
        } else if (__dealerChatKACOgLength < $liveChatKAC.length) {
          $('script[src="' + ets.src + '"]').remove();
          document.body.appendChild(ets);
        }

        $liveChatKAC.css('display', 'block');
        $liveChatKAC.on('click', function (e) {
          e.preventDefault();
        });
      }, 1500);
    }
  }
};
